<template>
  <v-card v-if="!isAuthenticated" class="mx-auto" flat color="white">
    <v-img v-if="!dense" max-height="220" src="@/assets/bluetheme/login.png"></v-img>
    <v-card-text>
      <v-row align="center">
        <v-col cols="12" sm="12" class="text-center">
          <v-form id="login" v-model="formValid">
            <v-text-field
              v-model="email"
              :rules="[rules.required]"
              label="E-mail"
              data-vv-name="email"
              required
              clearable
            ></v-text-field>
            <v-text-field
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="showPassword ? 'text' : 'password'"
              label="A-Z, a-z, number and special characters"
              hint="At least 8 characters"
              counter
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-form>
          <br />
          <div v-if="error">
            <v-alert type="error">{{ error }}</v-alert>
          </div>
          <v-card-actions class="text-center">
            <v-btn text :loading="loginLoading" :disabled="loginLoading" @click="onLogin()">Login</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :loading="registerLoading"
              :disabled="registerLoading"
              @click="onRegister"
            >Register</v-btn>
          </v-card-actions>
          <v-divider />
          <v-card-text id="firebaseui-auth-container" ref="firebaseui-auth-container"></v-card-text>
          <!-- <div id="firebaseui-auth-container" ref="firebaseui-auth-container"></div> -->
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { USER } from "@/store/actions.type";
import firebase from "firebase/app";

import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";

export default {
  name: "Login",
  props: {
    dense: {
      type: Boolean,
      default: false
    },
    redirect: {
      type: String,
      default: ""
    }
  },
  data: function() {
    return {
      email: null,
      password: null,
      showPassword: false,
      formValid: false,
      loginLoading: false,
      registerLoading: false,
      rules: {
        required: value => !!value || "Required.",
        min: v => (v && v.length >= 8) || "Min 8 characters"
      },
      error: null
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser", "errors"])
  },
  watch: {
    isAuthenticated(v) {
      if (v) this.$router.push(this.redirect || this.$route.query.redirect);
    }
  },

  created() {
    if (this.isAuthenticated) {
      this.$router.push(this.redirect || this.$route.query.redirect);
    }
  },

  mounted() {
    var vm = this; // this fix the issue 'this' is refer to callback function rather than vm.
    const uiConfig = {
      signInSuccessUrl: this.redirect,
      callbacks: {
        // Called when the user has been successfully signed in.
        signInSuccessWithAuthResult: function(authResult) {
          if (authResult.user) {
            // check Auth & save to Store
            vm.$store.dispatch(USER.SET, authResult.user);
          }
          return false;
        }
      },
      // Opens IDP Providers sign-in flow in a popup.
      signInFlow: "popup",
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID
      ]
    };
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }
    ui.start("#firebaseui-auth-container", uiConfig);
  },

  methods: {
    onLogin() {
      this.loginLoading = true;
      var cred = {
        email: this.email,
        password: this.password
      };
      this.$store
        .dispatch(USER.LOGIN, cred)
        .then(() => {
          this.loginLoading = false;
        })
        .catch(e => {
          // console.log(e);
          this.error = e.message;
          this.loginLoading = false;
          this.registerLoading = false;
        });
    },
    onRegister() {
      this.registerLoading = true;
      var cred = {
        email: this.email,
        password: this.password
      };
      this.$store
        .dispatch(USER.REGISTER, cred)
        .then(() => {
          this.registerLoading = false;
        })
        .finally(() => {
          this.registerLoading = false;
        });
    }
  }
};
</script>
